const ComprobanteBaseRules = (tipoDeComprobante, data = {}) => {
  const metodoPago = ['T', 'P'].indexOf(tipoDeComprobante) === -1 ? ['required'] : [];
  let formaPago = ['T', 'P'].indexOf(tipoDeComprobante) === -1 ? ['required'] : [];

  const facturaGlobalRequired = data.Receptor?.razon_social?.toUpperCase() === 'PUBLICO EN GENERAL'
    && data.Receptor?.rfc === 'XAXX010101000' ? 'required' : 'string';

  let conceptosRules = {
    'Conceptos': [
      'required',
    ],
    'Conceptos.Concepto': [
      'required',
    ],
    'Conceptos.Concepto.*.ClaveProdServ': [
      'required',
    ],
    'Conceptos.Concepto.*.NoIdentificacion': [
      'string',
      'min:1',
      'max:100',
      'regex:/^[^|]{1,100}$/',
    ],
    'Conceptos.Concepto.*.Cantidad': [
      'required',
      'min:0.01',
      'decimal:6',
      'min:0.000001',
    ],
    'Conceptos.Concepto.*.ClaveUnidad': [
      'required',
    ],
    'Conceptos.Concepto.*.Unidad': [
      'string',
    ],
    'Conceptos.Concepto.*.Descripcion': [
      'required',
      'string',
      'min:1',
      'max:1000',
      'regex:/^[^|]{1,1000}$/',
    ],
    'Conceptos.Concepto.*.ValorUnitario': [
      'required',
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
    'Conceptos.Concepto.*.Importe': [
      'required',
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
    'Conceptos.Concepto.*.Descuento': [
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
  };

  if (['N', 'P'].indexOf(tipoDeComprobante) !== -1) {
    conceptosRules = {};
  }

  if (['N'].indexOf(tipoDeComprobante) !== -1) {
    formaPago = [];
  }

  return {
    'Servicio': [
      'string',
      'min:1',
      'max:40'
    ],
    'OrdenId': [
      'string',
      'min:1',
      'max: 150'
    ],
    'Ciudad': [
      'string',
      'min:1',
      'max: 50'
    ],
    'Region': [
      'string',
      'min:1',
      'max: 50'
    ],
    'CfdiFecha': [
      // 'string',
      // 'date:Y-m-d H:i:s',
      // 'regex:/^(20[1-9][0-9])-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])\s(([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9])$/', // eslint-disable-line
    ],
    'ResidenciaFiscal': [
      'size:3',
    ],
    'FormaPago': [].concat(formaPago, ['in:01,02,03,04,05,06,08,12,13,14,15,17,23,24,25,26,27,28,29,30,31,99']),
    'CondicionesDePago': [
      'string',
      'min:1',
      'max:1000',
      'regex:/^[^|]{1,1000}$/',
    ],
    'SubTotal': [
      'required',
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
    'Descuento': [
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
    'Moneda': [
      'required',
      'in:AED,AFN,ALL,AMD,ANG,AOA,ARS,AUD,AWG,AZN,BAM,BBD,BDT,BGN,BHD,BIF,BMD,BND,BOB,BOV,BRL,BSD,BTN,BWP,BYR,BZD,CAD,CDF,CHE,CHF,CHW,CLF,CLP,CNY,COP,COU,CRC,CUC,CUP,CVE,CZK,DJF,DKK,DOP,DZD,EGP,ERN,ETB,EUR,FJD,FKP,GBP,GEL,GHS,GIP,GMD,GNF,GTQ,GYD,HKD,HNL,HRK,HTG,HUF,IDR,ILS,INR,IQD,IRR,ISK,JMD,JOD,JPY,KES,KGS,KHR,KMF,KPW,KRW,KWD,KYD,KZT,LAK,LBP,LKR,LRD,LSL,LYD,MAD,MDL,MGA,MKD,MMK,MNT,MOP,MRO,MUR,MVR,MWK,MXN,MXV,MYR,MZN,NAD,NGN,NIO,NOK,NPR,NZD,OMR,PAB,PEN,PGK,PHP,PKR,PLN,PYG,QAR,RON,RSD,RUB,RWF,SAR,SBD,SCR,SDG,SEK,SGD,SHP,SLL,SOS,SRD,SSP,STD,SVC,SYP,SZL,THB,TJS,TMT,TND,TOP,TRY,TTD,TWD,TZS,UAH,UGX,USD,USN,UYI,UYU,UZS,VEF,VND,VUV,WST,XAF,XAG,XAU,XBA,XBB,XBC,XBD,XCD,XDR,XOF,XPD,XPF,XPT,XSU,XTS,XUA,XXX,YER,ZAR,ZMW,ZWL'
    ],
    'TipoCambio': [
      'decimal:6',
      'min:0.000001',
    ],
    'Total': [
      'required',
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
    'TipoDeComprobante': [
      'required',
      'string',
      'in:Ingreso,Egreso,Traslado,Nomina,Pago',
    ],
    'MetodoPago': [].concat(metodoPago, ['in:PUE,PPD']),

    'InformacionGlobal': [
    ],
    'InformacionGlobal.periodicidad': [
      facturaGlobalRequired,
      'in:01,02,03,04,05',
      'min:2',
    ],
    'InformacionGlobal.meses': [
      facturaGlobalRequired,
      'in:01,02,03,04,05,06,07,08,09,10,11,12,13,14,15,16,17,18',
      'string',
      'min:2',
    ],
    'InformacionGlobal.año': [
      facturaGlobalRequired,
      'date:Y',
      'min:4',
    ],

    'CfdiRelacionados': [
    ],
    'CfdiRelacionados.TipoRelacion': [
      'required_with:CfdiRelacionados',
      'in:01,02,03,04,05,06,07,08,09'
    ],
    'CfdiRelacionados.CfdiRelacionado': [
      'required_with:CfdiRelacionados',
      'array',
    ],
    'CfdiRelacionados.CfdiRelacionado.*.UUID': [
      'required_with:CfdiRelacionados.CfdiRelacionado',
      'string',
      'size:36',
      'regex:/^[a-f0-9A-F]{8}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{4}-[a-f0-9A-F]{12}$/',
    ],
    'Emisor': [
      'required',
    ],
    'Emisor.id': [
      'required',
      'string',
      'min:1',
      'max:190'
    ],
    'Receptor': [
      'required',
    ],
    'Receptor.rfc': [
      'required',
      'string',
      'min:12',
      'max:13',
      'regex:/^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$/',
    ],
    'Receptor.nombre': [
      'string',
      'min:1',
      'max:254',
      'regex:/^[^|]{1,254}$/',
    ],

    /** Control interno cliente */

    'Receptor.grupo': [
      'string',
      'min:1',
      'max:40',
      'regex:/^[^|]{1,254}$/',
    ],
    'Receptor.grupo_id': [
      'string',
      'min:1',
      'max:150',
    ],

    /** ./Control interno cliente */

    'Receptor.residencia_fiscal': [
      'string',
      'in:AFG,ALA,ALB,DEU,AND,AGO,AIA,ATA,ATG,SAU,DZA,ARG,ARM,ABW,AUS,AUT,AZE,BHS,BGD,BRB,BHR,BEL,BLZ,BEN,BMU,BLR,MMR,BOL,BIH,BWA,BRA,BRN,BGR,BFA,BDI,BTN,CPV,KHM,CMR,CAN,QAT,BES,TCD,CHL,CHN,CYP,COL,COM,PRK,KOR,CIV,CRI,HRV,CUB,CUW,DNK,DMA,ECU,EGY,SLV,ARE,ERI,SVK,SVN,ESP,USA,EST,ETH,PHL,FIN,FJI,FRA,GAB,GMB,GEO,GHA,GIB,GRD,GRC,GRL,GLP,GUM,GTM,GUF,GGY,GIN,GNB,GNQ,GUY,HTI,HND,HKG,HUN,IND,IDN,IRQ,IRN,IRL,BVT,IMN,CXR,NFK,ISL,CYM,CCK,COK,FRO,SGS,HMD,FLK,MNP,MHL,PCN,SLB,TCA,UMI,VGB,VIR,ISR,ITA,JAM,JPN,JEY,JOR,KAZ,KEN,KGZ,KIR,KWT,LAO,LSO,LVA,LBN,LBR,LBY,LIE,LTU,LUX,MAC,MDG,MYS,MWI,MDV,MLI,MLT,MAR,MTQ,MUS,MRT,MYT,MEX,FSM,MDA,MCO,MNG,MNE,MSR,MOZ,NAM,NRU,NPL,NIC,NER,NGA,NIU,NOR,NCL,NZL,OMN,NLD,PAK,PLW,PSE,PAN,PNG,PRY,PER,PYF,POL,PRT,PRI,GBR,CAF,CZE,MKD,COG,COD,DOM,REU,RWA,ROU,RUS,ESH,WSM,ASM,BLM,KNA,SMR,MAF,SPM,VCT,SHN,LCA,STP,SEN,SRB,SYC,SLE,SGP,SXM,SYR,SOM,LKA,SWZ,ZAF,SDN,SSD,SWE,CHE,SUR,SJM,THA,TWN,TZA,TJK,IOT,ATF,TLS,TGO,TKL,TON,TTO,TUN,TKM,TUR,TUV,UKR,UGA,URY,UZB,VUT,VAT,VEN,VNM,WLF,YEM,DJI,ZMB,ZWE,ZZZ',
    ],
    'Receptor.uso_cfdi': [
      'required',
      'string',
      'in:G01,G02,G03,I01,I02,I03,I04,I05,I06,I07,I08,D01,D02,D03,D04,D05,D06,D07,D08,D09,D10,P01,S01,CP01,CN01',
    ],
    'Receptor.email': [
      'string',
      'min:1',
      'max:254',
      'regex:/^[^|]{1,254}$/',
    ],

    ...conceptosRules,

    'Impuestos': [

    ],
    'Impuestos.TotalImpuestosRetenidos': [
      'required_with:Impuestos.Retenciones',
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
    'Impuestos.TotalImpuestosTrasladados': [
      'required_with:Impuestos.Traslados',
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
    'Impuestos.Retenciones': [
      'required_with:Impuestos.TotalImpuestosRetenidos'
    ],
    'Impuestos.Retenciones.Retencion': [
      'required_with:Impuestos.Retenciones',
      'array',
    ],
    'Impuestos.Retenciones.Retencion.*.Impuesto': [
      'required_with:Impuestos.Retenciones',
      'string',
      'in:001,002,003',
    ],
    'Impuestos.Retenciones.Retencion.*.Importe': [
      'required',
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
    'Impuestos.Traslados': [
    ],
    'Impuestos.Traslados.Traslado': [
      'required_with:Impuestos.TotalImpuestosTrasladados',
      'array',
    ],
    'Impuestos.Traslados.Traslado.*.Impuesto': [
      'required',
      'string',
      'in:001,002,003',
    ],
    'Impuestos.Traslados.Traslado.*.TipoFactor': [
      'required',
      'string',
      'in:Tasa,Cuota,Exento',
    ],
    'Impuestos.Traslados.Traslado.*.TasaOCuota': [
      // 'required_unless:Impuestos.Traslados.Traslado.*.TipoFactor,Exento',
      'min:0.000000',
      'decimal:6',
    ],
    'Impuestos.Traslados.Traslado.*.Importe': [
      // 'required_unless:Impuestos.Traslados.Traslado.*.TipoFactor,Exento',
      'decimal:6',
      'min:0.000000',
      'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
    ],
    'Complemento': [
    ],
    'Addenda': [
    ],
  };
}

export default ComprobanteBaseRules;